import * as React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { debug } from '../../../utils';
const styles = require('./styles.less') as any;
const log = debug('lego:Account.tsx');
import ChangeEmailForm from './ChangeEmailForm';
import ChangePasswordForm from './ChangePasswordForm';
import { changeEmail, changePassword } from '../../models/Account';
import { logout } from '../../models/Auth';
import Button from '../../components/Button/Button';
import get from 'lodash/get';

const mapStateToProps = (state, ownProps) => ({
		user: get(state, 'account.data', {} as any) || {},
});
@connect(mapStateToProps, {changeEmail, changePassword, logout})
@reduxForm({form: 'account'})
export default class Account extends React.Component<any,any> {
    constructor(props) {
        super(props);
        this.state = {
            changingEmail: false,
            changingPassword: false
        };
    }

    setChangingPassword(state) {
        this.setState({ changingPassword: state });
    }

    setChangingEmail(state) {
        this.setState({ changingEmail: state });
    }

		render() {
				const { user } = this.props;
        const { changingEmail, changingPassword } = this.state;

				return (
						<div>
							<h1>Account Settings</h1>
              <Button type='button' kind='warn' onClick={()=>this.props.logout()} style={{}}>Logout</Button>
								<div className={styles.form}>
										<h2>Email address</h2>
                    <span>Your currently registered email address is: <b>{user.email}</b></span>
                    <div>
                      {!changingEmail && <Button type='button' onClick={() => this.setChangingEmail(true)}>Change Email</Button>}
						          {changingEmail && <ChangeEmailForm changeEmail={this.props.changeEmail} cancel={()=> this.setChangingEmail(false)} />}
                    </div>
								</div>
								<div className={styles.form}>
										<h2>Password</h2>
                    {!changingPassword && <Button type='button' onClick={() => this.setChangingPassword(true)}>Change Password</Button>}
										{changingPassword && <ChangePasswordForm changePassword={this.props.changePassword} cancel={()=> this.setChangingPassword(false)} />}
								</div>
						</div>
				);
		}
}



// WEBPACK FOOTER //
// ./src/app/containers/Account/Account.tsx